import { blackColors, successColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const departmentsStyle = {
	display: 'flex',
	flexWrap: 'wrap',
	'& > div': {
		marginRight: '4px',
		transition: 'all .1s ease-in-out',
		padding: '9px 8px 7px 8px',
		display: 'flex',
		alignItems: 'center',
		borderRadius: '16px',
		marginBottom: '8px',
		cursor: 'pointer',
		userSelect: 'none',
		'& svg': {
			color: whiteColor,
			marginLeft: '2px',
			width: '16px',
			height: '16px',
			position: 'relative',
			bottom: '1px',
		},
		'&:last-of-type': {
			marginRight: 0,
		},
	},
};

const addUserDialogStyle = (theme) => ({
	userName: {
		fontFamily: theme.fontFamily.alvar.regular,
		fontSize: theme.fontSize(18),
		lineHeight: theme.fontSize(22),
		color: successColor[0],
		marginTop: 25,
		marginBottom: 34,
	},
	userWillReceive: {
		paddingTop: 8,
		borderTop: `1px solid ${blackColors[6]}`,
	},
	dialogBodyWrapper: {
		paddingTop: '24px',
		minHeight: '480px',
		'& > div > div': {
			'&:last-of-type': {
				marginTop: '40px',
				maxWidth: '80%',
				width: '288px',
				margin: '0 auto',
			},
			'&:first-of-type': {
				height: '65px',
			},
		},
	},
	error: {
		color: '#d41565!important',
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	assignToAccount: {
		marginBottom: '8px',
	},
	departmentsWrapper: {
		marginTop: '40px',
		'& > div': {
			...departmentsStyle,
		},
	},
	notSelected: {
		opacity: 0.5,
	},
	expirationDateWrapper: {
		'& > div:first-of-type': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'flex-end',
			'& > label': {
				marginBottom: '4px',
				marginRight: 0,
				'& .MuiTypography-root': {
					position: 'relative',
					top: '2px',
				},
			},
		},
	},
	cell: {
		marginBottom: 0,
	},
	accountsWrapper: {
		marginTop: '36px',
	},
	smallMargin: {
		marginBottom: '8px',
	},
	mediumMargin: {
		marginBottom: '24px',
	},
	userTypeWrapper: {
		marginBottom: '20px',
		'& > label': {
			'& > span': {
				'&:last-of-type': {
					position: 'relative',
					top: '3px',
				},
			},
		},
	},
	userTypeBody: {
		marginTop: '10px',
	},
	badges: {
		width: '100%',
		textAlign: 'right',
		'& > div': {
			marginBottom: '2px',
		},
	},
	maxAdminCount: {
		textAlign: 'center',
		'& p:first-of-type': {
			marginBottom: '20px',
		},
	},
	adminsCountInfo: {
		marginTop: '20px',
	},
	contractInputWrapper: {
		[`& input[type=number]::-webkit-outer-spin-button,
		& input[type=number]::-webkit-inner-spin-button`]: {
			'-webkit-appearance': 'none',
			margin: 0,
		},
		'& input[type=number]': {
			'-moz-appearance': 'textfield',
		},
	},
	numberTag: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	customNumber: {
		width: '118px',
		display: 'inline-block',
		marginRight: 4,
	},
});

export default addUserDialogStyle;
